import { render } from "./PasoriSensorContainer.vue?vue&type=template&id=2188f667&scoped=true&ts=true"
import script from "./PasoriSensorContainer.vue?vue&type=script&lang=ts"
export * from "./PasoriSensorContainer.vue?vue&type=script&lang=ts"

import "./PasoriSensorContainer.vue?vue&type=style&index=0&id=2188f667&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2188f667"]])

export default __exports__